import { useState } from 'react';

import { faFilter } from '@fortawesome/free-solid-svg-icons';
import { Download } from 'lucide-react';

import PersonFiltersPopup from './components/PersonFilters';
import { Button } from '@/components/atoms/new-button';
import { FilterExpandableButton } from '@/components/molecules/FilterExpandableButton';
import CustomModal from '@/components/molecules/Modals/CustomModal';
import SearchBox from '@/components/molecules/SearchBox';
import Pagination from '@/components/organisms/Pagination';
import DataViewToolbar from '@/screens/Chronos/CaseEditor/DataView/components/TableToolbar';
import { PersonFilters } from '@/types';

interface PersonsEditorToolbarProps {
  globalFilter: string;
  clearSearch: () => void;
  setGlobalFilter: (value: string) => void;
  onSearchCall: () => void;
  currentPage: number;
  totalPages: number;
  activeFilters: PersonFilters;
  setFilters: (v: PersonFilters) => void;
  prevPage: () => void;
  nextPage: () => void;
  goToPage: (page: number) => void;
  openDownloadModal: () => void;
}

export const PersonsEditorToolbar = ({
  globalFilter,
  clearSearch,
  setGlobalFilter,
  onSearchCall,
  currentPage,
  totalPages,
  activeFilters,
  setFilters,
  prevPage,
  nextPage,
  goToPage,
  openDownloadModal,
}: PersonsEditorToolbarProps) => {
  const [filtersModalOpen, setFiltersModalOpen] = useState(false);
  const [activeFilterCount, setActiveFilterCount] = useState(0);

  return (
    <>
      <DataViewToolbar
        titleSection={<h1 className="text-lg font-semibold">Entities</h1>}
        actionButtons={
          <Button onClick={openDownloadModal} className="h-8 rounded-sm text-xs" variant="secondary">
            <Download className="h-3 w-3" />
            Download
          </Button>
        }
        filterButtons={
          <FilterExpandableButton filterCount={activeFilterCount} onClick={() => setFiltersModalOpen(true)} />
        }
        inlineSearchBar={
          <SearchBox
            value={globalFilter}
            onChange={setGlobalFilter}
            clearSearch={clearSearch}
            onSearchCall={onSearchCall}
            placeholder="Search entities..."
          />
        }
        pagination={
          <Pagination
            canGetPrevPage={currentPage > 0}
            canGetNextPage={currentPage < totalPages - 1}
            prevPage={prevPage}
            nextPage={nextPage}
            currentPage={currentPage}
            noOfPages={totalPages}
            goToPage={goToPage}
          />
        }
      />
      <CustomModal
        content={
          <PersonFiltersPopup
            activeFilters={activeFilters}
            setFilters={setFilters}
            handleClose={() => setFiltersModalOpen(false)}
            setActiveFilterCount={setActiveFilterCount}
            goToPage={goToPage}
          />
        }
        isOpen={filtersModalOpen}
        maxWidth="32rem"
        handleClose={() => setFiltersModalOpen(false)}
      />
    </>
  );
};
